var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 404,
    viewBox: "0 0 10 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24998 117.998C8.74998 117.998 10 119.305 10 120.873V126.623C10 128.192 8.74998 129.498 7.24998 129.498H5.625L5.625 391.998H4.375L4.375 129.498H2.75002C1.25002 129.498 0 128.192 0 126.623L0 120.873C0 119.305 1.25002 117.998 2.75002 117.998H4.375L4.375 0.498413L5.625 0.498413L5.625 117.998H7.24998Z",
    fill: "#ED1957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 394.873C10 393.305 8.74998 391.998 7.24998 391.998H2.75002C1.25002 391.998 0 393.305 0 394.873L0 400.623C0 402.192 1.25002 403.498 2.75002 403.498H7.24998C8.74998 403.498 10 402.192 10 400.623V394.873Z",
    fill: "#ED1957"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 258.373C10 256.805 8.74998 255.498 7.24998 255.498H2.75002C1.25002 255.498 0 256.805 0 258.373L0 264.123C0 265.692 1.25002 266.998 2.75002 266.998H7.24998C8.74998 266.998 10 265.692 10 264.123V258.373Z",
    fill: "#ED1957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLine);
export default __webpack_public_path__ + "static/media/vertical-line.27e8aeb824a8397a15c8f6a4fb55860f.svg";
export { ForwardRef as ReactComponent };